import React, { Component } from 'react';
import { RequiredFlagLabel } from '../../../styles/style';

class RequiredFlag extends Component {
  render() {
    const { text, show, children } = this.props;

    return (
      <div style={{position: 'relative'}}>
        {show && (<RequiredFlagLabel>{text}</RequiredFlagLabel>)}
        {children}
      </div>
    )
  }
}

export default RequiredFlag;
